import { Button, Radio, Typography, styled } from '@mui/material';
import type { ButtonProps, RadioProps, TypographyProps, Theme } from '@mui/material';

export const StyledBulleList = styled(Typography)<TypographyProps & { aslink?: string }>(ownerState => {
	return {
		lineHeight: 'normal',
		marginTop: ownerState.theme.spacing(1),
		marginLeft: ownerState.theme.spacing(2),
		position: 'relative',
		...(ownerState['aslink'] === 'true' && {
			textDecoration: 'underline',
			cursor: 'pointer',
		}),

		'&::before': {
			content: '"•"',
			position: 'absolute',
			left: `calc(-${ownerState.theme.spacing(2)})`,
			top: '1.5px',
		},
	};
});

export const BodyText = styled(Typography)<TypographyProps>(({ theme }: { theme: Theme }) => ({
	lineHeight: 'normal',
	marginTop: theme.spacing(1),
	marginBottom: '0',
}));

export const SectionTitle = styled(Typography)<TypographyProps>(({ theme }: { theme: Theme }) => ({
	lineHeight: 'normal',
	marginTop: theme.spacing(1),
	marginBottom: 0,
	padding: 0,

	'&::after': {
		content: 'none',
	},
}));

export const RadioInput = styled(Radio)<RadioProps>(({ theme }: { theme: Theme }) => ({
	'&.Mui-checked': {
		color: `${theme.palette.hsbcColor.blue_sapphire} !important`,
	},
	'&.Mui-checked .MuiSvgIcon-root path': {
		fill: `${theme.palette.hsbcColor.blue_sapphire} !important`,
	},
}));

export const DialogActionsButton = styled(Button)<ButtonProps>(({ theme }: { theme: Theme }) => ({
	padding: '10px 0',
	maxWidth: '50%',
	boxSizing: 'border-box',
	textTransform: 'uppercase',
	flex: 1,
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	textWrap: 'inherit',

	'&:hover': {
		backgroundColor: theme.palette.tsGoColor.grayLight(0.3),
	},
}));
